import { CartAddEvent } from '@theme/events';
import { fetchConfig } from '@theme/utilities';

const ADD_SELECTOR = '[data-product-size-add]';

/**
 * Adds a variant from a product card size button (desktop hover sizes).
 * @param {HTMLButtonElement} button
 */
async function addSizeFromButton(button) {
  const variantId = button.dataset.variantId;
  if (!variantId || button.getAttribute('aria-busy') === 'true') return;

  button.setAttribute('aria-busy', 'true');

  const formData = new FormData();
  formData.set('id', variantId);
  formData.set('quantity', '1');

  const cartItemsComponents = document.querySelectorAll('cart-items-component');
  const sectionIds = [];

  for (const item of cartItemsComponents) {
    if (item instanceof HTMLElement && item.dataset.sectionId) {
      sectionIds.push(item.dataset.sectionId);
    }
  }

  if (sectionIds.length > 0) {
    formData.append('sections', sectionIds.join(','));
  }

  const fetchCfg = fetchConfig('javascript', { body: formData });

  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      ...fetchCfg,
      headers: {
        ...fetchCfg.headers,
        Accept: 'application/json'
      }
    });
    const data = await response.json();

    if (data.status) {
      button.dispatchEvent(
        new CartAddEvent({}, button.dataset.productId || '', {
          didError: true,
          source: 'product-size-add',
          productId: button.dataset.productId,
          variantId,
          itemCount: 1
        })
      );
      return;
    }

    let cart;

    try {
      const cartResponse = await fetch('/cart.js');
      cart = await cartResponse.json();
    } catch {
      cart = undefined;
    }

    button.dispatchEvent(
      new CartAddEvent(cart, variantId, {
        source: 'product-size-add',
        productId: button.dataset.productId,
        variantId,
        itemCount: 1,
        sections: data.sections
      })
    );
  } catch (error) {
    console.error(error);
  } finally {
    button.removeAttribute('aria-busy');
  }
}

/**
 * @param {MouseEvent} event
 */
function onDocumentClick(event) {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const button = target.closest(ADD_SELECTOR);
  if (!(button instanceof HTMLButtonElement)) return;

  event.preventDefault();
  event.stopPropagation();
  addSizeFromButton(button);
}

document.addEventListener('click', onDocumentClick);
